import { sortByDateCreated } from '../util/date/dateUtils';
import React from 'react';
import { ChangeSet } from './ChangeSet';
export class ChangeSetList {
  constructor() {
    let reviewedObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let t = arguments.length > 1 ? arguments[1] : undefined;
    this.reviewedObject = reviewedObject;
    this.t = t;
  }
  getChangeSets() {
    let reviewType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    const matchingChangeSets = reviewType ? this.reviewedObject.change_sets.filter(changeSet => changeSet.review_type === reviewType) : this.reviewedObject.change_sets;
    const sortedChangeSets = (matchingChangeSets === null || matchingChangeSets === void 0 ? void 0 : matchingChangeSets.sort(sortByDateCreated)) || [];
    const changeSetModels = sortedChangeSets.map(changeSet => new ChangeSet({
      changeSet,
      t: this.t
    }));
    return changeSetModels;
  }
  getLatestChangeSet() {
    let reviewType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return this.getChangeSets(reviewType)[0];
  }
}